export default {

  data: () => ({
    selectedItems:    null,
    getItems:         null,
  }),

  methods: {
    set_selectedItems() {
      this.selectedItems = { 
        ...this.selectedItems,
        current: JSON.parse(JSON.stringify(this.current))
      }
    },

    draw_PDF() {
      if (this.getItems.current) this.current = this.getItems.current;
      this.draw_Forms() //-----> Redrawing
    },
  },

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
  },
  
}